(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    function currentVariantId(card) {
      const checked = card.querySelector('input[type="radio"][data-variant-id]:checked');
      if (checked) return checked.getAttribute('data-variant-id');

      const li = card.closest('[data-sezerium-variant]');
      if (li) return li.getAttribute('data-sezerium-variant');

      const idInput = card.querySelector('input[name="id"]');
      return idInput ? idInput.value : null;
    }

    function applyLabel(card) {
      const dataEl = card.querySelector('.product-card__label-data');
      const labelEl = card.querySelector('.product-card__custom-label');
      if (!dataEl || !labelEl) return;

      let map;
      try { map = JSON.parse(dataEl.textContent); } catch (e) { return; }

      const id = currentVariantId(card);
      const text = id ? map[String(id)] : '';
      labelEl.textContent = text ? '[ ' + text + ' ]' : '';
      labelEl.hidden = !text;
    }

    function run(root) {
      root = root || document;
      if (root.matches && root.matches('product-card')) applyLabel(root);
      if (root.querySelectorAll) root.querySelectorAll('product-card').forEach(applyLabel);
    }

    document.addEventListener('DOMContentLoaded', function () { run(); });

    // label volgt de gekozen kleur-swatch binnen dezelfde kaart
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('input[type="radio"][data-variant-id]')) {
        const card = e.target.closest('product-card');
        if (card) applyLabel(card);
      }
    });

    // Sezerium kan kaarten ná load injecteren/herschikken
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) run(n); });
      });
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
